import { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useStore } from "../../../stores";
import locale from "../../../constants/locale";
import styles from "./ChatInfo.module.scss";

const ArchiveButton = observer(() => {
  const { t } = useTranslation();
  const { selectedChat, setArchiveStatus } = useStore("chats");
  const [isLoading, setIsLoading] = useState(false);

  if (!selectedChat) {
    return null;
  }

  const handleClick = async () => {
    setIsLoading(true);
    await setArchiveStatus(!selectedChat.archived);
    setIsLoading(false);
  };

  return (
    <button
      className={clsx(styles.actionBtn, "button", { "is-loading": isLoading })}
      onClick={handleClick}
      disabled={selectedChat.isConnected}
      title={
        selectedChat.isConnected ? t(locale.cannotArchiveConnectedChat) : ""
      }
    >
      <span className="icon">
        <i className="fas fa-archive"></i>
      </span>
      <span>
        {t(selectedChat.archived ? locale.unarchive : locale.archived)}
      </span>
    </button>
  );
});

export default ArchiveButton;
